const initial_state = {
  genangan_update: 0,
  array_genangan_success: [],
  array_genangan_failed: [],
  array_genangan_message_failed: [],
  geojson_contour_all: {
    type: "FeatureCollection",
    features: [],
  },
  geojson_contour_notflooded: {
    type: "FeatureCollection",
    features: [],
  },
  geojson_contour_flooded: {
    type: "FeatureCollection",
    features: [],
  },
  geojson_polygon_convex: {
    type: "FeatureCollection",
    features: [],
  },
  geojson_polygon_not_flooded: {
    type: "FeatureCollection",
    features: [],
  },
  geojson_grid_elevation: {
    type: "FeatureCollection",
    features: [],
  },
  geojson_flood_square: {
    type: "FeatureCollection",
    features: [],
  },
  features_polygon_convex: [],
  features_polygon_new_algorithm: [],
  genangan_mdpl: 0,
  contourCreated: false,
  feature_key_selected_genangan: "",
  feature_key_params_genangan: "",
  feature_object_selected_genangan: {},
  latitude_params_genangan: 0,
  longitude_params_genangan: 0,
  genangan_cm_params_genangan: 0,
  feature_key_failed_genangan: "",
  current_progress_genangan: 0,
  is_dem_visible: false,
  // radius_titik_dem: 300,
  total_union: 1,
  current_union: 0,
  tinggi_titik_dem_terdekat: 0,
  //new modular flood
  flood_level_cm: 0,
  flood_level_cm_editable: 0,
  nearest_feature_mdpl_meter: 0,
  flood_level_mdpl_meter: 0,
  flood_level_mdpl_meter_editable: 0,
  flooded_point_features: [],
  point_buffer_features: [],
  geojson_filtered_fix: {
    type: "FeatureCollection",
    features: [],
  },
  geojson_flood_in_progress: {
    type: "FeatureCollection",
    features: [],
  },
  feature_flood: {},
  features_flood_server: [],
  polygon_key_active_array: [],
  //progress & trivial
  is_skip_get_dem_server: false,
  total_dem: 100,
  current_dem: 0,
  total_calc: 100,
  current_calc: 0,
  min_mdpl: 0,
  max_mdpl: 1,
  enlarge_extrude: 1,
  visibility_extrude: "none",
  visibility_flood: "none",
  total_radius_meters: 100,
  total_batches: 100,
};

export default function dataReducer(state = initial_state, action) {
  switch (action.type) {
    case "set_value_genangan":
      return {
        ...state,
        [action.payload.key]: action.payload.value,
      };
    case "push_value_genangan":
      return {
        ...state,
        [action.payload.key]: [
          ...state[action.payload.key],
          action.payload.value,
        ],
      };
    case "find_and_replace_value_genangan":
      return {
        ...state,
        [action.payload.key]: state[action.payload.key].map((item, index) => {
          if (item.properties.feature_key === action.payload.feature_key) {
            return action.payload.value;
          } else {
            return item;
          }
        }),
      };

    case "delete_value_genangan":
      return {
        ...state,
        [action.payload.key]: state[action.payload.key].filter(
          (item) =>
            item.properties.feature_key !==
            action.payload.properties.feature_key
        ),
      };

    case "pull_value_genangan_string":
      return {
        ...state,
        ...pull_value_genangan_string(
          action.payload.key,
          state[action.payload.key],
          action.payload.value
        ),
      };
    case "pull_value_genangan_object":
      return {
        ...state,
        ...pull_value_genangan_object(
          action.payload.key,
          state[action.payload.key],
          action.payload.value,
          action.payload.key_child
        ),
      };
    case "genangan_update":
      return {
        ...state,
        genangan_update: state.genangan_update + 1,
      };

    default:
      return state;
  }
}

const pull_value_genangan_string = (key, list, value) => {
  list = list.filter((item) => item !== value);
  return { [key]: list };
};

const pull_value_genangan_object = (key, list, value, key_child) => {
  list = list.filter((item) => item[key_child] !== value);
  return { [key]: list };
};
